import { Mask, evBus, GEV } from "../core/instances";

class MaskLayer {
    $pages = new Map();
    $showing = -1;

    $init(...pages) {
        for (let i = 0; i < pages.length; ++i) {
            this.$pages.set(i, pages[i]);
        }
        this.#$setupEventListeners();
    }

    #$setupEventListeners() {
        evBus.on(GEV.GAME_RESET, (...args) => {
            if (args[0].removeMask) this.$hide();
            else this.$show(0);
        });
        evBus.on(GEV.GAME_START, () => this.$hide());
        evBus.on(GEV.GAME_PAUSE, () => this.$show(1));
        evBus.on(GEV.GAME_RESUME, () => this.$hide());
        evBus.on(GEV.GAME_OVER, () => this.$show(2, false));
    }

    $show(i, autoShow = true) {
        if (this.$showing >= 0) {
            Mask.show_("#FFF", 0, 0.4, 0.5);
            this.$pages.get(this.$showing).hide_();
        } else {
            Mask.show_("#FFF", 0, 0.4, 0.8);
        }
        autoShow && this.$pages.get(i).show_();
        this.$showing = i;
    }

    $hide() {
        if (this.$showing >= 0) {
            this.$pages.get(this.$showing).hide_();
        }
        this.$showing = -1;
        Mask.hide_();
    }
}

export const ML = new MaskLayer();
export default ML;
